import MediumButtonStyled from '../../components/Buttons/MediumButtonStyled';
import ContentBoardStyled from '../../components/ContentBoardStyled';

import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  & > .body {
    display: flex;
    flex-direction: row;
    height: 100%;
  }
`;

export const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 246px;
  width: 246px;
  margin: 25px 25px 0 0;
`;

export const ActivityTitle = styled.div`
  padding-top: 4px;
  font-family: NunitoSans;
  font-size: 20px;
  font-weight: bold;
  color: #283890;
`;

export const ActivityTable = styled.div`
  display: contents;
  height: 100%;
  overflow: hidden;
`;

export const LinkStyled = styled(Link)`
  color: #283890 !important;
  display: flex;
  align-items: center;
  font-weight: 700;
`;

export const ActivityTableRow = styled.div`
  ${(props) => css`
    display: grid;
    ${props.type === 'requests'
      ? css`
          grid-template-columns: 124px 54px 70px 1fr 1fr 150px 50px 56px 66px;
          gap: 0 8px;
          font-size: 12px;
        `
      : `grid-template-columns: 205px ${Array.from(Array((props.columns || 10) - 1))
          .map(() => '2fr')
          .join(' ')};
    gap: 0 20px;
    font-size: 14px;`}
    border-bottom: 1px solid #ccc;
    min-height: 54px;
    margin: 4px 0;

    ${Boolean(props?.head) &&
    css`
      font-size: 12px;
      font-weight: bold;
      text-transform: uppercase;
      align-items: flex-start;
      min-height: unset;
      padding-bottom: 10px;
    `}

    & > div {
      display: flex-inline;
      text-align: center;
      margin: auto 0;

      &:first-child {
        text-align: left;
        justify-content: start;
      }

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    & .up {
      color: #26762f;
    }
    & .down {
      color: #a81b23;
    }

    & .fails {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      font-size: 10px;
      min-width: 142px;
    }
  `}
`;

export const ActivityHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const ActivityHeaderCol = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ActivityHeaderInfoCol = styled.div`
  display: flex;
  flex-direction: row;
  gap: 18px;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    margin-bottom: 24px;

    & > div {
      display: flex;
    }

    span {
      text-align: right;
      display: inline-block;

      &:nth-child(1) {
        font-size: 10px;
        font-weight: bold;
        color: #677b8b;
        min-width: 130px;
      }

      &:nth-child(2) {
        font-size: 14px;
        color: #28283a;
        padding-left: 10px;
        min-width: 48px;
      }
    }

    & .fails, .general-stat {
    {
      display: flex;
      flex-direction: column;
      width: 140px;
      & > .value {
        font-size: 10px;
        color: #28283a;
        text-align: right;
        & span {
          min-width: 46px;
        }
      }

      & > span {
        margin-left: 20px;
        text-align: left;
      }
    }
  }

    & .general-stat {
      width: 196px;
      & > .value {
        & span {
          min-width: 86px;
        }
      }
    }
    & .image-stat {
      width: 234px;
    }
`;

export const ActivityDuration = styled.div`
  color: #677b8b;
  font-size: 16px;
  line-height: 18px;
  font-weight: 700;
  display: flex;
  flex-direction: row;
  padding: 8px 0px;

  & > div {
    cursor: pointer;
  }

  & > .active {
    color: #283890;
    pointer-events: none;
  }

  & > .middle {
    padding: 0 10px;
    margin: 0 10px;
    border-left: 1px solid #677b8b;
    border-right: 1px solid #677b8b;
  }
`;

export const ContentBoard = styled(ContentBoardStyled)`
  padding: 18px 22px;
  width: calc(100% - 94px);
  margin-bottom: 0px;
  ${(p) => p.heightCorrection && `height: calc(100% - ${p.heightCorrection || 94}px);`}
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 2px 7px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;

  ${({ status }) => {
    if (status >= 200 && status < 300)
      return css`
        background: #e6f4ea;
        color: #26762f;
      `;
    if (status >= 400 && status < 500)
      return css`
        background: #fff3e0;
        color: #e65100;
      `;
    if (status >= 500)
      return css`
        background: #fdecea;
        color: #a81b23;
      `;
    return css`
      background: #edf2f9;
      color: #677b8b;
    `;
  }}
`;

export const VerifiedDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ verified }) => (verified ? '#26762f' : '#a81b23')};
  margin-right: 5px;
`;

export const MethodTag = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #283890;
`;

export const SummaryStats = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  align-items: flex-start;
`;

export const StatCard = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 120px;

  .label {
    font-size: 10px;
    font-weight: bold;
    color: #677b8b;
    text-transform: uppercase;
    margin-bottom: 4px;
  }

  .value {
    font-size: 22px;
    color: #28283a;
    line-height: 1.2;
    display: flex;
    align-items: baseline;
  }
`;

export const ActivityTableFooter = styled.div`
  padding: 16px 22px 0;
  text-align: right;
  font-size: 11px;
  color: #677b8b;
  flex-shrink: 0;
`;

export const ExportButtonStyled = styled(MediumButtonStyled)`
  position: fixed;
  bottom: 24px;
  right: 32px;
`;
